module.exports = __webpack_public_path__ + "static/media/down-arrow-icon.3878006b.svg";